<template>
  <v-row>
    <v-col cols="12">
      <h4 class="mb-2"> {{ $t('contract.timingSection') }} </h4>

      <vf-date-input
        :label="$t('contract.signatureDate')"
        v-model="form.signatureDate"
        outlined
        @change="validationModel.form.signatureDate.$touch()"
        :error-messages="errorMessages(validationModel.form.signatureDate, 'signatureDate')"
      />

      <vf-date-input
        :label="$t('contract.commencementDate')"
        v-model="form.commencementDate"
        outlined
        @change="validationModel.form.commencementDate.$touch()"
        :error-messages="errorMessages(validationModel.form.commencementDate, 'commencementDate')"
      />

      <vf-date-input
        :label="$t('contract.completionTime')"
        v-model="form.completionTime"
        outlined
        @change="validationModel.form.completionTime.$touch()"
        :error-messages="errorMessages(validationModel.form.completionTime, 'completionTime')"
      />

      <vf-date-input
        :label="$t('contract.finalTakingOver')"
        v-model="form.takingOverDate"
        outlined
        @change="validationModel.form.takingOverDate.$touch()"
        :error-messages="errorMessages(validationModel.form.takingOverDate, 'takingOverDate')"
      />
    </v-col>
  </v-row>
</template>

<script>
import dayjs from 'dayjs'

export default {
  name: 'TimingSection',
  props: ['form', 'validationModel', 'errorMessages'],
  computed: {
    adjustedCompletionTime () {
      const days = dayjs(this.form.adjustedCompletionTime).diff(
        this.form.completionTime,
        'day'
      )

      const adjustedCompletionTime = this.form.adjustedCompletionTime
        ? `(${days > 0 ? '+' : ''}${days})`
        : ''

      return adjustedCompletionTime
    }
  },
  data () {
    return {
      signatureDateMenu: false,
      commencementDateMenu: false,
      completionTimeMenu: false
    }
  }
}
</script>
